export const adaptivePlannerQueryKeys = {
  backlogItems: {
    all: ({ planId }: { planId: number }) => ['backlogItems', planId],
    detail: ({ planId, itemId }: { planId?: number; itemId: number }) => [
      'backlogItems',
      planId,
      'detail',
      itemId,
    ],
    dataSet: ({ planId, filters }: { planId: number; filters?: unknown }) => [
      'dataSet',
      'backlogItems',
      planId,
      filters,
    ],
    dataSetAll: ({ planId }: { planId: number }) => ['dataSet', 'backlogItems', planId],
    dataSetsByPlanIds: ({ planIds }: { planIds: number[] }) => [
      'dataSets',
      'backlogItems',
      planIds,
    ],
    assignedTeamIds: ({ planId }: { planId: number }) => [
      'assignedTeamIds',
      'backlogItems',
      planId,
    ],
    count: ({ planId, filters }: { planId: number; filters?: unknown }) => [
      'count',
      'backlogItems',
      planId,
      filters,
    ],
    countAll: ({ planId }: { planId: number }) => ['count', 'backlogItems', planId],
    itemsProxyAll: ({ planId }: { planId: number }) => ['items-proxy', 'backlogItems', planId],
    itemProxy: ({ planId, itemId }: { planId: number; itemId: number }) => [
      ...adaptivePlannerQueryKeys.backlogItems.itemsProxyAll({ planId }),
      itemId,
    ],
    itemsProxyBulk: ({ planId, itemIds }: { planId: number; itemIds: number[] }) => {
      const sortedItemIds = [...itemIds].sort((a, b) => a - b);
      return [
        ...adaptivePlannerQueryKeys.backlogItems.itemsProxyAll({ planId }),
        'bulk',
        sortedItemIds.join(','),
      ];
    },
    itemDependencies: ({ planId, itemId }: { planId: number; itemId: number }) => [
      ...adaptivePlannerQueryKeys.backlogItems.itemsProxyAll({ planId }),
      'dependencies',
      itemId,
    ],
  },
  plans: {
    all: () => ['plans'],
    detail: ({ planId }: { planId: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'detail',
      planId,
    ],
    byLoopId: ({ loopId }: { loopId: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'detail',
      loopId,
    ],
    allAlerts: ({ planId }: { planId: number }) => [
      ...adaptivePlannerQueryKeys.plans.all(),
      'alerts',
      planId,
    ],
    alerts: ({ planId, alertTypes }: { planId: number; alertTypes?: string[] }) => [
      ...adaptivePlannerQueryKeys.plans.allAlerts({ planId }),
      alertTypes,
    ],
    latestSnapshot: ({
      planId,
      includeMetrics = false,
    }: {
      planId: number;
      includeMetrics?: boolean;
    }) => [...adaptivePlannerQueryKeys.plans.all(), 'latestSnapshot', planId, includeMetrics],
  },
  scenarios: {
    dataset: ({ planId }: { planId: number }) => ['scenarios', 'dataset', planId],
    all: ({ planId }: { planId: number }) => ['scenarios', planId],
    disabled: () => ['scenarios', 'disabled'],
    detail: ({ planId }: { planId: number }) => [
      ...adaptivePlannerQueryKeys.scenarios.all({ planId }),
      'detail',
    ],
    lastActivateResult: ({ planId }: { planId: number }) => [
      ...adaptivePlannerQueryKeys.scenarios.all({ planId }),
      'lastActivateResult',
    ],
  },
  scenarioItems: {
    all: ({ planId }: { planId: number }) => ['scenarioItems', planId],
    detail: ({ planId, itemId }: { planId?: number; itemId?: number }) => [
      'scenarioItems',
      planId,
      'detail',
      itemId,
    ],
  },
  timeline: {
    allDataSetsForPlan: ({ planId }: { planId: number }) => ['timeline', 'dataSet', planId],
    allBulkFetchesForPlan: ({ planId }: { planId: number }) => ['timeline', 'bulkFetch', planId],
    dataSet: ({ planId }: { planId: number }) => ['timeline', 'dataSet', planId],
    bulkFetch: ({ planId }: { planId: number }) => ['timeline', 'bulkFetch', planId],
    detail: ({ planId, itemId }: { planId: number; itemId: number }) => [
      'timeline',
      'detail',
      planId,
      itemId,
    ],
  },
  schedulesProxy: {
    byItemIds: ({ planId, itemIds }: { planId: number; itemIds: number[] }) => {
      const sortedItemIds = [...itemIds].sort((a, b) => a - b);
      return ['schedulesProxy', planId, sortedItemIds.join(',')];
    },
  },
  virtualResources: {
    planVirtualResources: ({ planId }: { planId: number }) => ['virtualResources', planId],
  },
};
